import React from "react";
import { Add } from "../../components/Add";

export const New = () => (
  <>
    <h2>New book</h2>
    <Add />
  </>
);
